import Transform from './Base';
import store from '@/store';

const getFormatTable = (arr1 = [], arr2 = []) => arr1.map(({ code, label, value }) => {
  const val2 = arr2.find(el => el.code === code);
  return {
    label,
    teamA: value,
    teamB: val2?.value ?? '',
  }
});

export default class StatisticTransform extends Transform {
  static frame({ data, frame_id }) {
    if (!data?.team_a || !data?.team_b) {
      return null;
    }

    return {
      id: frame_id,
      teamA: {
        ...data.team_a,
        color: store.getters['project/detectsFiltered'].find(el => el.team_id === data.team_a.team_id)?.color || 'yellow',
      },
      teamB: {
        ...data.team_b,
        color: store.getters['project/detectsFiltered'].find(el => el.team_id === data.team_b.team_id)?.color || 'black',
      },
    }
  }

  static game(data = {}) {
    const { team_a, team_b } = data;
    return {
      ...data,
      table: getFormatTable(team_a?.stats, team_b?.stats),
    };
  }

  static players(arr) {
    return arr.map(({ player_name, player_number, ...other }) => ({
      ...other,
      player: {
        player_name,
        player_number,
      },
    }));
  }
}
